import React from 'react'
import { useTranslation } from '@mc/i18n'
import IconTrust from '../assets/roleplay/icon-trust.svg'
import Image from './Image'
import { TrackingSectionContainer } from './TrackingSectionContainer'

export const TrustSection = ({
  rowAnalytics,
  style = {},
  className = '',
}: {
  rowAnalytics: {
    rowName: string
    rowPositionIndex: number
  }
  style?: React.CSSProperties
  className?: string
}) => {
  const { t } = useTranslation('@mc/persona')

  return (
    <TrackingSectionContainer analytics={rowAnalytics} className={className}>
      <div
        className='container d-flex flex-column align-items-center mc-corners--lg mc-px-4 mc-px-sm-8 mc-pt-3 mc-pb-9 col-12 col-sm-9'
        style={{ ...style }}
      >
        <IconTrust className='mc-mb-2' />
        <h2 className='mc-text-h1 mc-text--center mc-mb-4 mc-px-2'>
          {t('coaching.trust.title')}
        </h2>
        <h3 className='mc-text-large mc-text--center mc-opacity--hinted mc-mb-4 mc-px-6'>
          {t('coaching.trust.subtitle')}
        </h3>
        <Image
          width={366}
          height={60}
          src='https://static.masterclass.com/roleplay-lp-trust-coaches.png'
          alt={t('coaching.trust.imgAlt')}
        />
      </div>
    </TrackingSectionContainer>
  )
}
